import {createActions, handleActions} from 'redux-actions';
import {actions as dirtyActions} from '../dirty.state';
import {push} from 'react-router-redux';
import jsonFetch from '../jsonFetch';
import handleError from '../handleError';

const standardActions = createActions(
	{},
	'USER_NEW',
	'USER_NEW_SAVED',
	'USER_SAVING',
	'USER_SAVED',
	'USER_REMOVE_NEW',
	'USER_LIST_RETRIEVING',
	'USER_LIST_RETRIEVED',
	'USER_UPDATE',
	'USER_NEW_UPDATE_EMAIL',
	'USER_ERROR'
);

export const actions = {
	...standardActions,
	cancel: email => (dispatch, getState) => {
		if (email === 'new') {
			dispatch(standardActions.userRemoveNew(email));
			dispatch(dirtyActions.dirtyClear(email));
			dispatch(push('/user')); // Go back to the list
			return;
		}
		
		const {users} = getState();
		
		const thisUser = users.items.find(item => item.email === email);
		
		if (!thisUser) return; // TODO standardise error handling
		
		dispatch(standardActions.userSaving(email));
		
		jsonFetch(`${process.env.REACT_APP_API}/user/${email}`)
			.then(json => {
				dispatch(dirtyActions.dirtyClear(email));
				dispatch(standardActions.userSaved(null));
				dispatch(standardActions.userUpdate(json));
				dispatch(push('/user')); // Go back to the list
			})
			.catch(handleError(dispatch))
	},
	save: email => (dispatch, getState) => {
		const {users} = getState();
		const thisUser = users.items.find(item => email === 'new' ? item.isNew : item.email === email);
		
		if (!thisUser) return; // TODO standardise error handling
		
		dispatch(standardActions.userSaving(email));
		
		jsonFetch(thisUser.isNew ? `${process.env.REACT_APP_API}/user` : `${process.env.REACT_APP_API}/user/${email}`, {
			headers: {
				'Content-Type': 'application/json'
			},
			method: thisUser.isNew ? 'POST' : 'PUT',
			body: JSON.stringify({
				email: thisUser.isNew ? thisUser.email : undefined,
				imagePath: thisUser.imagePath,
				firstname: thisUser.firstname,
				lastname: thisUser.lastname,
				permissions: thisUser.permissions
			})
		})
			.then(() => {
				dispatch(dirtyActions.dirtyClear(email));
				dispatch(standardActions.userSaved(null));
				if (thisUser.isNew) {
					dispatch(standardActions.userNewSaved(null));
					dispatch(push(`/user/${thisUser.email}`)); // Go back to the list
				}
			})
			.catch(handleError(dispatch))
	}
};

export const reducer = handleActions({
	[actions.userListRetrieving]: state => ({
		...state,
		retrieving: true,
		items: []
	}),
	[actions.userListRetrieved]: (state, {payload}) => ({
		...state,
		retrieving: false,
		items: [...payload]
	}),
	[actions.userSaving]: (state, {payload}) => ({
		...state,
		saving: payload
	}),
	[actions.userSaved]: state => ({
		...state,
		saving: null
	}),
	[actions.userUpdate]: (state, {payload}) => ({
		...state,
		items: state.items.map(item => {
			if ((payload.isNew && item.isNew) || item.email === payload.email) {
				return {...item, ...payload}; // Partial update
			} else {
				return item;
			}
		})
	}),
	[actions.userNew]: state => ({
		...state,
		items: [...state.items.filter(item => !item.isNew), {
			email: '',
			firstname: 'New',
			lastname: 'User',
			isNew: true,
			permissions: [],
			imagePath: null
		}]
	}),
	[actions.userRemoveNew]: state => ({
		...state,
		items: state.items.filter(item => !item.isNew)
	}),
	[actions.userNewSaved]: state => ({
		...state,
		items: state.items.map(item => {
			if (item.isNew) {
				return {
					...item,
					isNew: undefined
				};
			} else {
				return item;
			}
		})
	}),
	[actions.userNewUpdateEmail]: (state, {payload}) => ({
		...state,
		items: state.items.map(item => {
			if (item.isNew) {
				return {
					...item,
					email: payload
				};
			} else {
				return item;
			}
		})
	})
}, {
	retrieving: false,
	saving: null,
	items: [],
	errorMessage: null
});



// WEBPACK FOOTER //
// ./src/users/users.state.js